import {
    CreateQuoteHistoryModel,
    GetCreateQuoteHistoryApiParameter,
    getExportQuoteHistory,
} from "@NA/Services/ADIQuoteHistoryExport";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    HasOnComplete,
    HasOnSuccess,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<
    GetCreateQuoteHistoryApiParameter & HasOnSuccess & HasOnComplete,
    CreateQuoteHistoryModel
>;

export const CreateExportFile: HandlerType = async (props: any) => {
    props.apiResult = await getExportQuoteHistory(props.parameter);
};

export const DownloadExportFile: HandlerType = async (props: any) => {
    const fileName = props.apiResult.result;
    const url = `/api/v1/export/getfile?file=${fileName}`;
    const response = await fetch(url);
    const blob = await response.blob();
    const objectURL = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectURL;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectURL);
};

export const chain = [CreateExportFile, DownloadExportFile];

const getQuoteHistoryExportHandler = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        customerSequence: "",
        sort: "",
        dateType: "",
        toDate: "",
        fromDate: "",
        status: "",
        selectedpage: "",
        ordersearchtype: "",
        isSearch: "",
        dateRange: "",
        dateRangeDesc: "",
        statusDesc: "",
        quotetype: "",
        quotetypeDesc: "",
        properties: "",
        currentPage: "",
        pageSize: "",
        poNumber: "",
        isSearchActive: false,
    },
    "getQuoteHistoryExportHandler",
);
export default getQuoteHistoryExportHandler;
